<template>
  <div class="px-5">
    <portal to="portal-menu-principal-topbar" tag="div">
      <BarraDeMenuPrincipal />
    </portal>

    <div class="d-flex align-center">
      <h3>{{`Dashboard${NOME_DEPARTAMENTO}`}}</h3>

      <v-spacer />

      <Configuracao />

      <CardsTotalizadores />
    </div>

    <div id="indicadores-or-detalhes-produto">
      <DetalhesProduto v-if="categoria_selecionada" />
      <Indicadores v-else />
    </div>

    <v-divider class="mt-2" />

    <TabelaDepartamento class="mt-1" />
  </div>
</template>

<script>
import BarraDeMenuPrincipal from "./BarraDeMenuPrincipal.vue";
import CardsTotalizadores from "./CardsTotais/CardsTotalizadores.vue";
import Indicadores from "./indicadores/Index.vue";
import DetalhesProduto from "./DetalhesCategoria/Index.vue";
import ReponsividadeDeAltura from "./../../../helpers/ResponsiveHeight.js";
import TabelaDepartamento from "./TabelaDepartamento";
import {categoria_selecionada} from "./helpers/CategoriaSelecionado.js";
import {parametros_rota} from "./helpers/ParametrosRota";
import Configuracao from "./Configuracao";

import {find} from "../../../api/compraPorDepartamentos/Departamento";
import {logout} from "../../../helpers";

export default {
  name: "Index",
  mixins: [ReponsividadeDeAltura, categoria_selecionada, parametros_rota],
  components: {
    TabelaDepartamento,
    BarraDeMenuPrincipal,
    CardsTotalizadores,
    Indicadores,
    DetalhesProduto,
    Configuracao
  },
  computed: {
    DEPARTAMENTO_COMPRA: {
      get() {
        return this.$store.getters["comprasPorDepartamentos/departamento_compra"];
      },
      set(valor) {
        this.$store.dispatch("comprasPorDepartamentos/departamento_compra", valor);
      }
    },
    NOME_DEPARTAMENTO() {
      const {descricao_departamento} = this.DEPARTAMENTO_COMPRA;

      if (!descricao_departamento) return '';

      const decricao_formatada = `${descricao_departamento[0] || ''}`.toUpperCase();
      return `/${decricao_formatada.concat(descricao_departamento.substring(1).toLowerCase())}`
    }
  },
  watch: {
    departamento_compra() {
      this.buscarDetalhesDepartamento();
    }
  },
  mounted() {
    this.buscarDetalhesDepartamento();
  },
  methods: {
    buscarDetalhesDepartamento() {
      find(this.departamento_compra).then(this.setDetalhesDepartamento).catch(logout)
    },
    setDetalhesDepartamento(detalhes) {
      this.DEPARTAMENTO_COMPRA = detalhes;
    }
  }
}
</script>

<style scoped>
#indicadores-or-detalhes-produto {
  height: 275px;
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(181, 181, 181, 0.82);
  border-radius: 8px;
}
</style>
